<script>
    import metrics from "../../stores/metrics.js";
    import cairn from "../../stores/cairn.js";
    import t from "../../localization/t.js";

    $: duration = (() => {
        const days = Math.floor($metrics.duration / 1000 / 60 / 60 / 24);

        const hours = Math.floor(
            $metrics.duration / 1000 / 60 / 60 - days * 24
        );

        const minutes = Math.floor(
            $metrics.duration / 1000 / 60 - days * 24 * 60 - hours * 60
        );

        return t("metrics.duration_value", { days, hours, minutes });
    })();

    $: distance = ($metrics.distance * 0.000621371).toFixed();

    $: emissions =
        $metrics.emissions < 1000.0
            ? t("metrics.emissions_value_g", {
                  g: Math.trunc($metrics.emissions)
              })
            : t("metrics.emissions_value_kg", {
                  kg: Math.trunc($metrics.emissions / 1000.0)
              });

    $: states = $metrics.states.length;

    $: progress = (($metrics.distance / 6_832_000_000) * 100).toFixed(4) + "%";
</script>

<div class="metrics">
    <table width="100%" cellpadding="0" cellspacing="0">
        <tr>
            <td width="50%">{t("metrics.duration_title")}</td>
            <td>{duration}</td>
        </tr>
        <tr>
            <td>{t("metrics.distance_title")}</td>
            <td> {distance} miles</td>
        </tr>
        <tr>
            <td>{t("metrics.emissions_title")}</td>
            <td>{emissions}</td>
        </tr>
        <tr title={$metrics.states.join(", ")}>
            <td>{t("metrics.states_visited_title")}</td>
            <td>{states}</td>
        </tr>
        <tr>
            <td>{t("metrics.cairns_discovered_title")}</td>
            <td>{$cairn.all.length - $cairn.buildCount || 0}</td>
        </tr>
        <tr>
            <td>{t("metrics.exploration_title")}</td>
            <td>{progress}</td>
        </tr>
    </table>
</div>

<style>
    td {
        border-top: black 1px solid;
        border-right: black 1px solid;
        background: var(--chrome-hsl);
        background: white;
        padding: var(--chrome-depth);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    tr:last-child td {
        border-bottom: black 1px solid;
    }

    tr td:first-child {
        border-top: var(--border-color-light) var(--chrome-depth) outset;
        border-right: var(--border-color-dark) var(--chrome-depth) outset;
        border-bottom: var(--border-color-dark) var(--chrome-depth) outset;
        border-left: var(--border-color-light) var(--chrome-depth) outset;
        background: var(--chrome-hsl);
    }
</style>
